import React from 'react';
import { fontEndConfig } from '@/shared/utils';
import { Tag } from 'antd';
import { dealIsAuction, dealPlatformType } from './functions';
import { dealValueShow } from '@/shared/functions';
/** @desc 创建表格列中的项函数 函数定义与antd保持一致 */
const createColumn = (title) => {
    return (otherProps) => {
        let _tempOtherProps = {};
        typeof (otherProps) === 'string' ? _tempOtherProps = { dataIndex: otherProps } : _tempOtherProps = otherProps;
        if (!_tempOtherProps.hasOwnProperty('width')) {
            /** @desc 默认列宽度为150 */
            _tempOtherProps.width = 150;
        }
        const _r = Object.assign({ title }, _tempOtherProps);
        return _r;
    };
};
/** @desc 买家姓名 */
const defaultUserName = createColumn('买家姓名');
/** @desc 手机号 */
const defaultMobile = createColumn('手机号');
/** @desc 出价总次数 */
const defaultOfferCount = createColumn('出价总次数');
/** @desc 所属机构 */
const defaultAffiliation = createColumn('所属机构');
/** @desc 是否可参拍 */
const defaultIfInPart = createColumn('是否可参拍');
/** @desc 出价会员数 & 本机构出价会员数 - columns */
const offerColumns = [defaultUserName({
        key: 'username',
        align: 'left',
        render: (text, record, index) => {
            const { buyerName, platformType } = record;
            switch (platformType) {
                case 1:
                    return (<div>
            <div> {buyerName ? buyerName : fontEndConfig.noValueReplace}</div>
            <div>
              <Tag style={{ marginTop: '6px' }}>自有车商</Tag>
            </div>
          </div>);
                case 0:
                    return (<div>
            <div> {buyerName ? buyerName : fontEndConfig.noValueReplace}</div>
            <div>
              <Tag style={{ marginTop: '6px' }}>车易拍车商</Tag>
            </div>
          </div>);
                default:
                    return (<div>
            <div> {buyerName ? buyerName : fontEndConfig.noValueReplace}</div>
            <div>
              <span>{fontEndConfig.noValueReplace}</span>
            </div>
          </div>);
            }
        },
    }), defaultMobile({
        key: 'buyerPhone',
        align: 'left',
        render: (text, record, index) => {
            const { buyerPhone } = record;
            if (!buyerPhone) {
                return <span>{fontEndConfig.noValueReplace}</span>;
            }
            return <span>{buyerPhone}</span>;
        },
    }), defaultOfferCount({
        key: 'times',
        align: 'left',
        render: (text, record, index) => {
            const { times } = record;
            if (!times) {
                return <span>{fontEndConfig.noValueReplace}</span>;
            }
            return <span>{times}</span>;
        },
    }), defaultAffiliation(({
        key: 'platformtype',
        align: 'left',
        render: (text, record, index) => {
            const { platformType } = record;
            switch (platformType) {
                case 1:
                    return <span>本机构</span>;
                case 0:
                    return <span>车易拍</span>;
                default:
                    return <span>{fontEndConfig.noValueReplace}</span>;
            }
        },
    }))];
/** @desc 关注会员数 & 本机构关注会员数 - columns */
const focusColumns = [defaultUserName({
        dataIndex: 'buyerName',
        render: (text, record, index) => (<div>
      {dealValueShow(text)}
      {!text ?
            <Tag style={{
                marginLeft: '8px',
                backgroundColor: '#f2f3f5',
                border: '1px solid #eaeaea',
                color: '#666',
            }}>
          未登录用户
        </Tag> : null}
    </div>),
    }), defaultMobile({
        dataIndex: 'buyerPhone',
        render: (text, record, index) => dealValueShow(text),
    }), defaultIfInPart({
        dataIndex: 'isAuction',
        render: (text, record, index) => dealIsAuction(text),
    }), defaultAffiliation({
        dataIndex: 'platformType',
        render: (text, record, index) => dealPlatformType(text),
    })];
/** @desc 在线会员数-columns   目前其定义以及处理同focusColumns */
const onlineColumns = focusColumns;
/**
 * @desc 模态框
 */
export default function modalTitleAndTableColumns(type) {
    switch (type) {
        case 'offer':
            return { columns: offerColumns, title: '出价会员' };
        case 'focus':
            return { columns: focusColumns, title: '关注会员', remark: '注：关注会员中不包含车易拍用户' };
        case 'online':
            return { columns: onlineColumns, title: '在线会员', remark: '注：在线会员中不包含车易拍用户' };
        case 'localOffer':
            return { columns: offerColumns, title: '本机构出价会员' };
        case 'localFocus':
            return { columns: focusColumns, title: '本机构关注会员' };
        case 'localOnline':
            return { columns: onlineColumns, title: '本机构在线会员' };
        default:
            console.error('您传入的type类型暂不支持');
            return { columns: [], title: '非支持类型表格弹框' };
    }
}
